'use client';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { PadlockLockedFillIcon } from '@navikt/aksel-icons';
import cl from 'clsx/lite';
import { Label } from '../../label/label.js';
import { Paragraph } from '../../paragraph/paragraph.js';

const ComboboxLabel = ({ label, description, hideLabel, size, readOnly, formFieldProps, }) => {
    return (jsxs(Fragment, { children: [label && (jsxs(Label, { "data-size": size, htmlFor: formFieldProps.inputProps.id, className: cl('ds-combobox__label', hideLabel && `ds-sr-only`), children: [readOnly && (jsx(PadlockLockedFillIcon, { "aria-hidden": true, className: 'ds-combobox__readonly__icon' })), label] })), description && (jsx(Paragraph, { asChild: true, "data-size": size, children: jsx("div", { id: formFieldProps.descriptionId, className: cl('ds-combobox__description', hideLabel && `ds-sr-only`), children: description }) }))] }));
};
ComboboxLabel.displayName = 'ComboboxLabel';

export { ComboboxLabel as default };
